module.exports = __webpack_public_path__ + "static/media/office_5@2x.65d24afb.jpg";